import {useEffect, useState} from 'react'
import {Route, Routes} from 'react-router-dom'
import {PageLink, PageTitle} from '../../_metronic/layout/core'
import {homeListCategoryTree} from '../modules/auth/core/_requests'
import {AxiosError} from 'axios'
import {useLang} from '../../_metronic/i18n/Metronici18n'
import SelectContent from '../pages/SelectContent'
import SelectCategory2 from '../pages/SelectCategory2'
import {useIntl} from 'react-intl'
import {Error404} from '../modules/errors/components/Error404'

function CategoryRoutes() {
  const [menuCategoryUnit, setMenuCategoryUnit] = useState<any>([])
  const [contentPaths, setContentPaths] = useState<string[]>([])
  const [categoryPaths, setCategoryPaths] = useState<string[]>([])

  const lang = useLang()
  const intl = useIntl()

  const getList = async () => {
    try {
      // const {data} = await homeListCategoryTree(true, 0, 0, '', lang, '', '')
      const {data} = await homeListCategoryTree(true, 0, 0, '', 'en', '', '')
      setMenuCategoryUnit(data[0].subList)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      setMenuCategoryUnit([])
      console.error(error)
    }
  }

  useEffect(() => {
    getList()
  }, [])

  useEffect(() => {
    if (menuCategoryUnit.length) {
      const allContentPaths: string[] = []
      const allCateogyrPaths: string[] = []
      menuCategoryUnit.forEach((category: any) => {
        const contentPaths = generateContentPaths(category)
        allContentPaths.push(...contentPaths)
        const categoryPaths = generateCategoryPaths(category)
        allCateogyrPaths.push(...categoryPaths)
      })
      setContentPaths(allContentPaths)
      setCategoryPaths(allCateogyrPaths)
    }
  }, [menuCategoryUnit])

  function convertToEnglishChars(str: string) {
    const turkishChars: {[key: string]: string} = {
      ı: 'i',
      ğ: 'g',
      ü: 'u',
      ş: 's',
      ö: 'o',
      ç: 'c',
      İ: 'I',
      Ğ: 'G',
      Ü: 'U',
      Ş: 'S',
      Ö: 'O',
      Ç: 'C',
    }

    return str.replace(/[^A-Za-z0-9_-]/g, (char) => {
      return turkishChars[char] || ''
    })
  }

  function generateCategoryPaths(data: any) {
    const paths: any = []

    function traverse(node: any, prefix = '') {
      const id = node.id
      const parentId = node.parentId
      const path = `${prefix}/${convertToEnglishChars(
        node.nodeAd.toLowerCase().replace(/\s/g, '-')
      )}`

      if (node.subList) {
        node.subList.forEach((subNode: any) => {
          const subPath = `${path}/${convertToEnglishChars(
            subNode.nodeAd.toLowerCase().replace(/\s/g, '-')
          )}`

          if ((subPath.match(/\//g) || []).length > 2) {
            paths.push({id, parentId, path})
          }

          traverse(subNode, path)
        })
      }
    }
    traverse(data)
    return paths
  }

  function generateContentPaths(data: any) {
    const paths: any = []

    function traverse(node: any, prefix = '') {
      const id = node.id
      const parentId = node.parentId
      const path = `${prefix}/${convertToEnglishChars(
        node.nodeAd.toLowerCase().replace(/\s/g, '-')
      )}`

      if (node.subList) {
        node.subList.forEach((subNode: any) => {
          traverse(subNode, path)
        })
      } else {
        paths.push({id, parentId, path})
      }
    }

    traverse(data)
    return paths
  }

  if (contentPaths.length === 0) {
    return null
  }

  return (
    <Routes>
      {contentPaths.map((item: any, index: number) => {
        const selecExperimentDetailBreadCrumbs: Array<PageLink> = [
          {
            title: intl.formatMessage({id: 'SLIDEMENU.HOME'}),
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
          {
            title: 'Units',
            path: '/units',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '/units' + item?.path,
            isSeparator: true,
            isActive: false,
          },
        ]
        return (
          <Route
            key={index}
            path={`${item?.path}`}
            element={
              <>
                <PageTitle breadcrumbs={selecExperimentDetailBreadCrumbs}>
                  {intl.formatMessage({id: 'SLIDEMENU.EXPERIMENTDETAIL'})}
                </PageTitle>
                <SelectContent id={item?.id} parentId={item.parentId} />
              </>
            }
          />
        )
      })}
      {Array.from(new Set(categoryPaths)).map((item: any, index: number) => {
        const selecCategoryBreadCrumbs: Array<PageLink> = [
          {
            title: intl.formatMessage({id: 'SLIDEMENU.HOME'}),
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '/units' + item.path,
            isSeparator: true,
            isActive: false,
          },
        ]
        return (
          <Route
            key={index}
            path={`${item.path}`}
            element={
              <>
                <PageTitle breadcrumbs={selecCategoryBreadCrumbs}>
                  {intl.formatMessage({id: 'SLIDEMENU.UNITS'})}
                </PageTitle>
                <SelectCategory2 id={Number(item.id)} parentId={item.parentId} />
              </>
            }
          />
        )
      })}

      <Route
        path='*'
        element={
          <div className='d-flex justify-content-center align-items-center '>
            <div className='text-center d-flex flex-column align-items-center'>
              <Error404 />
            </div>
          </div>
        }
      />
    </Routes>
  )
}

export default CategoryRoutes
